import { useTranslate } from "@tolgee/react";
import { PageLoader } from "#/components/ui/page-loader";
import { useMe } from "#/hooks/use-me";
import { useWallet } from "#/hooks/use-wallet";
import { ReferralCodeCard } from "./referral-code-card";
import { ReferralEarningsCard } from "./referral-earnings-card";
import { ReferralLoginGate } from "./referral-login-gate";
import { ReferralsList } from "./referrals-list";
import { WithdrawalsHistory } from "./withdrawals-history";

export function ReferralsLayout() {
	const { t } = useTranslate();
	const wallet = useWallet();
	const me = useMe();

	if (!wallet.isReady || (wallet.isAuthenticated && !wallet.isConnected)) {
		return <PageLoader />;
	}

	if (!wallet.isConnected) {
		return (
			<ReferralLoginGate
				onLogin={() => wallet.connect("referrals")}
				loginDisabled={!wallet.isReady}
			/>
		);
	}

	const referralCode = me.data?.referral_code ?? null;
	const referredByCode = me.data?.referred_by_code ?? null;

	return (
		<div className="mx-auto flex max-w-3xl flex-col divide-y divide-border p-4 pt-10 pb-16 [&>*]:py-6 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0">
			<header>
				<h1 className="text-title1 text-foreground">{t("referrals.title")}</h1>
				<p className="mt-1 text-body2 text-muted-foreground">
					{t("referrals.subtitle")}
				</p>
				{referredByCode ? (
					<p className="mt-2 text-label2 text-muted-foreground">
						{t("referrals.referred-by", { code: referredByCode })}
					</p>
				) : null}
			</header>

			<ReferralCodeCard existingCode={referralCode} />
			<ReferralEarningsCard enabled={referralCode !== null} />
			<WithdrawalsHistory />
			<ReferralsList />
		</div>
	);
}
